import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { bonusAdminBody } from "./bonusAdminBody";
import type { TemplateOut } from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

async function fetchTemplates(): Promise<TemplateOut[]> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const response = await instance.get(API_ROUTES.LIST_DYNAMIC_BONUS_TEMPLATES);
  return bonusAdminBody<TemplateOut[]>(response) ?? [];
}

export const LIST_TEMPLATES_QUERY_KEY = ["LIST_DYNAMIC_BONUS_TEMPLATES"] as const;

export const useListTemplates = () => {
  return useQuery<TemplateOut[]>({
    queryKey: LIST_TEMPLATES_QUERY_KEY,
    queryFn: fetchTemplates,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
